import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import MySelect from "../Common/MySelect";
import FireIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_fire-01.svg2";
import TerroristIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_terrorist-01.svg2";
import TrafficIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_terrorist-01.svg2";
import WeatherIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_weather.svg2";
import CreateIcon from "../../assets/icons/Icon_Library/application icons/assets/events/add_circle-01.svg2";
import MapIcon from "../../assets/icons/mapping.svg2";
import AssetIcon from "../../assets/icons/asset-01.svg2";
import MyModal from "../Common/MyModal";
import MyMap from "../Maps/MyMap";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { SolutionEvent } from "../store/slices/settingsSlice";
import { getAssetValueLabels, loadAssetOptionsPaginated } from "../proxyAPI";
import Clusters from "../Maps/Clusters";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import { getOverlayLocation, toCamel } from "../Maps/helpers";
import MapSelection from "../Maps/MapSelection";
import { MapAssetItems, MapItems } from "../Maps/MapSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faTrash, faX } from "@fortawesome/free-solid-svg-icons";
import MyCollapse from "../Common/MyCollapse";
import { components } from "react-select";
import Contacts from "../Contacts/Contacts";
import { useListContactsAndGroupsInLocationQuery } from "../store/slices/mapsSlice";
import ContactsList from "../Contacts/ContactsList";
import MyPagination from "../Common/MyPagination";

const mapAssetFilters = {
  Assets: true,
  Contacts: false,
  Direct: true,
  Indirect: false,
  ExcludeWithLocation: false,
  OnlyItemsWithEvents: false,
  EventsUuids: [],
  weatherFilters: {
    isWeather: false,
    showGrids: false,
    StartAt: "",
    EndAt: "",
    range: -1,
    period: "daily",
    alertFilters: { conditionIds: [], conditions: [], search: "" },
  },
  weatherForecastFilters: {
    isForecast: false,
    start: "",
    radius: 30,
    steps: 8,
  },
  eventsFilters: {
    isEvent: false,
    severityLevel: "",
    period: "daily",
    range: -1,
  },

  Limit: 12,
  Offset: 0,
  WithContacts: true,
  Zoom: 30,
};
const mapContactFilters = {
  Assets: false,
  Contacts: true,
  Direct: true,
  Indirect: false,
  ExcludeWithLocation: false,
  OnlyItemsWithEvents: false,
  EventsUuids: [],
  weatherFilters: {
    isWeather: false,
    showGrids: false,
    StartAt: "",
    EndAt: "",
    range: -1,
    period: "daily",
    alertFilters: { conditionIds: [], conditions: [], search: "" },
  },
  weatherForecastFilters: {
    isForecast: false,
    start: "",
    radius: 30,
    steps: 8,
  },
  eventsFilters: {
    isEvent: false,
    severityLevel: "",
    period: "daily",
    range: -1,
  },

  Limit: 12,
  Offset: 0,
  WithContacts: true,
  Zoom: 30,
};

const alertOptions = [
  {
    value: "fire",
    label: (
      <span className="align-items-center">
        <FireIcon width={25} className="me-2" /> Fire
      </span>
    ),
  },
  {
    value: "terroristThread",
    label: (
      <span>
        <TerroristIcon width={25} className="me-2" /> Terrorist Thread
      </span>
    ),
  },
  {
    value: "trafficAlert",
    label: (
      <span>
        <TrafficIcon width={25} className="me-2" /> Traffic Alert
      </span>
    ),
  },
  {
    value: "weatherAlert",
    label: (
      <span>
        <WeatherIcon width={25} className="me-2" />
        Weather Alert
      </span>
    ),
  },
  {
    value: "createANewCategory",
    label: (
      <span>
        <CreateIcon width={25} className="me-2" />
        Create a new category
      </span>
    ),
  },
];

const filters = {
  Contacts: false,
  Assets: false,
  Direct: false,
  Indirect: false,
  ExcludeWithLocation: false,
  AssetUuids: [],
};

export default function EventDetails({
  event,
  setEvent,
  affected,
  setAffected,
  initialData,
}: {
  event: Partial<SolutionEvent> | undefined;
  setEvent: React.Dispatch<
    React.SetStateAction<Partial<SolutionEvent> | undefined>
  >;
  affected: { contacts: number; assets: number };
  setAffected: React.Dispatch<
    React.SetStateAction<{ contacts: number; assets: number }>
  >;
  initialData?: Partial<SolutionEvent> | undefined;
}) {
  const { data: contactsAndGroupsData } =
    useListContactsAndGroupsInLocationQuery(
      event?.ContactsAndAssetsCriteria || {},
      { skip: !event?.ContactsAndAssetsCriteria }
    );

  useEffect(() => {
    if (contactsAndGroupsData) {
      const contactsCount = contactsAndGroupsData?.contacts?.length || 0;
      setAffected((prev) => {
        if (prev.contacts === contactsCount) {
          return prev;
        }

        return {
          ...prev,
          contacts: contactsCount,
        };
      });
    }
  }, [contactsAndGroupsData, setAffected]);

  return (
    <Row className="py-3 mt-2 ps-4 pe-4 m-2">
      <Col className="col-6 border-end pe-4">
        {/* Selected Assets */}
        <div className="mb-4">
          <div className="fw-bold fs-4">Assets</div>
          {event?.Areas?.[0]?.geometry?.coordinates ||
          event?.Assets?.length ||
          event?.ContactsAndAssetsCriteria?.Coordinates ||
          event?.ContactsAndAssetsCriteria?.IncludeAssets?.length ? (
            <div className="">
              <MapAssetItems
                bounds={event?.ContactsAndAssetsCriteria?.Coordinates}
                filters={
                  {
                    ...mapAssetFilters,
                    OrAssetUuids:
                      event?.ContactsAndAssetsCriteria?.IncludeAssets,
                    AndNotAssetUuids:
                      event?.ContactsAndAssetsCriteria?.ExcludeAssets,
                  } as any
                }
                showActions={false}
                tableStyle={{ maxHeight: 300, overflow: "auto" }}
                actionButtons={(a) =>
                  !initialData?.ContactsAndAssetsCriteria?.IncludeAssets?.includes(
                    a.Uuid
                  ) ? (
                    <button
                      className="btn bg-purple-gradient border-0 text-purple btn-small"
                      onClick={() => {
                        setEvent((prev) => ({
                          ...prev,
                          Assets: (prev?.Assets || []).filter(
                            (uuid) => uuid !== a.Uuid
                          ),
                          ContactsAndAssetsCriteria: {
                            ...prev?.ContactsAndAssetsCriteria,
                            ExcludeAssets: [
                              ...(prev?.ContactsAndAssetsCriteria
                                ?.ExcludeAssets || []),
                              a.Uuid,
                            ],
                            IncludeAssets:
                              prev?.ContactsAndAssetsCriteria?.IncludeAssets?.filter(
                                (uuid) => uuid !== a.Uuid
                              ) || [],
                          },
                        }));
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  ) : null
                }
                onLoadComplete={(data) => {
                  setAffected((prev) => {
                    if (prev.assets === data.total) {
                      return prev;
                    }

                    return {
                      ...prev,
                      assets: data.total,
                    };
                  });
                }}
              />
            </div>
          ) : (
            <div className="alert alert-secondary">No criteria selected.</div>
          )}
        </div>

        {/* Selected contacts */}
        <div className="mb-4">
          <div className="fw-bold fs-4">Contacts</div>
          {event?.Areas?.[0]?.geometry?.coordinates ||
          event?.Assets?.length ||
          event?.Contacts?.length ||
          event?.ContactsAndAssetsCriteria?.Coordinates ||
          event?.ContactsAndAssetsCriteria?.IncludeContacts?.length ? (
            <div className="">
              <ContactsList
                contacts={toCamel(contactsAndGroupsData?.contacts) || []}
                contactButton={(c: any) => {
                  const isIgnored =
                    event?.ContactsAndAssetsCriteria?.ExcludeContacts?.includes(
                      c.uuid
                    );
                  return (
                    <button
                      className={`btn btn-small ${
                        isIgnored ? "btn-outline-success" : "bg-purple-gradient"
                      } border-0 text-purple`}
                      onClick={() => {
                        setEvent({
                          ...event,
                          Contacts: (event.Contacts || []).filter(
                            (uuid) => uuid !== c.uuid
                          ),
                          ContactsAndAssetsCriteria: {
                            ...event.ContactsAndAssetsCriteria,
                            IncludeContacts: isIgnored
                              ? [
                                  ...(event.ContactsAndAssetsCriteria
                                    ?.IncludeContacts || []),
                                  c.uuid,
                                ]
                              : (
                                  event.ContactsAndAssetsCriteria
                                    ?.IncludeContacts || []
                                ).filter((uuid) => uuid !== c.uuid),
                            ExcludeContacts: isIgnored
                              ? (
                                  event.ContactsAndAssetsCriteria
                                    ?.ExcludeContacts || []
                                ).filter((uuid) => uuid !== c.uuid)
                              : [
                                  ...(event.ContactsAndAssetsCriteria
                                    ?.ExcludeContacts || []),
                                  c.uuid,
                                ],
                          },
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={isIgnored ? faX : faTrash} />
                    </button>
                  );
                }}
                allContactsButton={undefined}
                refreshList={undefined}
                notDraggable={undefined}
                fullView={undefined}
                isModal={undefined}
                showContactFields={undefined}
                onSelectContacts={undefined}
              />
            </div>
          ) : (
            <div className="alert alert-secondary">No criteria selected.</div>
          )}
        </div>
      </Col>

      <Col className="col-6 border-end pe-4">
        {/* Assets Manual selection */}
        <div className="mb-4">
          <span className="fs-4 fw-bold">Select Assets Manually</span>
          <div className="text-secondary">
            <Input
              placeholder="Select assets"
              isDisabled={
                !!initialData?.ContactsAndAssetsCriteria?.IncludeAssets?.length
              }
              value={event?.ContactsAndAssetsCriteria?.IncludeAssets || []}
              onChange={(values: any) => {
                setEvent((prev) => ({
                  ...prev,
                  Assets: values,
                  ContactsAndAssetsCriteria: {
                    ...prev?.ContactsAndAssetsCriteria,
                    IncludeAssets: values,
                    ExcludeAssets:
                      prev?.ContactsAndAssetsCriteria?.ExcludeAssets?.filter(
                        (uuid) => !values.includes(uuid)
                      ) || [],
                  },
                }));
              }}
              loadOptions={loadAssetOptionsPaginated as any}
              getValueLabels={getAssetValueLabels as any}
              options={undefined}
              inputType="select"
              isMulti
              isClearable
              components={{
                ValueContainer: (props: any) => {
                  const valueCount = props.selectProps.value?.length || 0;
                  const inputChildren = React.Children.toArray(
                    props.children
                  ).filter((child: any) => {
                    if (!React.isValidElement(child)) {
                      return false;
                    }

                    const childTypeName = (child.type as any)?.name;

                    return (
                      Object.prototype.hasOwnProperty.call(
                        child?.props || {},
                        "isHidden"
                      ) || childTypeName === "Input"
                    );
                  });

                  return (
                    <components.ValueContainer
                      {...props}
                      className={`${
                        props.className || ""
                      } d-flex align-items-center flex-nowrap`}
                    >
                      <span>{valueCount || "No"} assets manually selected</span>
                      {inputChildren}
                    </components.ValueContainer>
                  );
                },
              }}
            />
          </div>
        </div>

        {/* From map */}
        <div className="mb-4">
          <span className="fs-4 fw-bold">Select contacts from map</span>
          <Form.Check
            type="switch"
            id="use-assets-switch"
            label="Use contacts associated to assets in map area"
            checked={event?.ContactsAndAssetsCriteria?.UseAssets}
            onChange={(e) =>
              setEvent((prev) => ({
                ...prev,
                ContactsAndAssetsCriteria: {
                  ...prev?.ContactsAndAssetsCriteria,
                  UseAssets: e.target.checked,
                },
              }))
            }
          />
          <Form.Check
            type="switch"
            id="use-contacts-switch"
            label="Use contacts in map area"
            disabled={
              !!initialData?.ContactsAndAssetsCriteria?.IncludeAssets?.length
            }
            checked={event?.ContactsAndAssetsCriteria?.UseContacts}
            onChange={(e) =>
              setEvent((prev) => ({
                ...prev,
                ContactsAndAssetsCriteria: {
                  ...prev?.ContactsAndAssetsCriteria,
                  UseContacts: e.target.checked,
                },
              }))
            }
          />
        </div>

        {/* Ignored assets */}
        {!!event?.ContactsAndAssetsCriteria?.ExcludeAssets?.length && (
          <div className="mb-4">
            <MyCollapse
              heading={
                <div className="fw-bold fs-4 flex-grow-1 d-flex align-items-center justify-content-between">
                  Ignored assets
                  <span className="badge rounded-pill bg-secondary ms-2 fs-6">
                    {event?.ContactsAndAssetsCriteria?.ExcludeAssets?.length}
                  </span>
                </div>
              }
            >
              <div className="mt-2">
                <div className="d-flex justify-content-end">
                  <button
                    className="btn border-0 text-purple btn-small btn-outline-light border-0 p-0 px-3"
                    onClick={() =>
                      setEvent((prev) => ({
                        ...prev,
                        ContactsAndAssetsCriteria: {
                          ...prev?.ContactsAndAssetsCriteria,
                          ExcludeAssets: [],
                        },
                      }))
                    }
                    title="Remove all ignored contacts"
                  >
                    Clear all
                  </button>
                </div>
                <MapAssetItems
                  bounds={undefined}
                  filters={
                    {
                      OrAssetUuids:
                        event?.ContactsAndAssetsCriteria?.ExcludeAssets,
                    } as any
                  }
                  showActions={false}
                  tableStyle={{ maxHeight: 300, overflow: "auto" }}
                  actionButtons={(a) => (
                    <button
                      className="btn bg-purple-gradient border-0 text-purple btn-small"
                      onClick={() => {
                        setEvent((prev) => ({
                          ...prev,
                          ContactsAndAssetsCriteria: {
                            ...prev?.ContactsAndAssetsCriteria,
                            ExcludeAssets:
                              prev?.ContactsAndAssetsCriteria?.ExcludeAssets?.filter(
                                (uuid) => uuid !== a.Uuid
                              ),
                          },
                        }));
                      }}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                />
              </div>
            </MyCollapse>
          </div>
        )}

        {/* Contacts Manual selection */}
        <div className="mb-4">
          <span className="fs-4 fw-bold">
            Select Contacts Manually{" "}
            <span className="text-secondary small">
              {!!event?.ContactsAndAssetsCriteria?.IncludeContacts?.length
                ? `(${event.ContactsAndAssetsCriteria.IncludeContacts.length} selected)`
                : ""}
            </span>
          </span>
          <div>
            <Input
              placeholder="Select contacts"
              value={event?.ContactsAndAssetsCriteria?.IncludeContacts || []}
              onChange={(values: any) => {
                setEvent((prev) => ({
                  ...prev,
                  Contacts: values,
                  ContactsAndAssetsCriteria: {
                    ...prev?.ContactsAndAssetsCriteria,
                    IncludeContacts: values,
                    ExcludeContacts:
                      prev?.ContactsAndAssetsCriteria?.ExcludeContacts?.filter(
                        (uuid) => !values.includes(uuid)
                      ) || [],
                  },
                }));
              }}
              inputType="contact"
              isMultiple
              hideList
            />
          </div>
        </div>

        {/* Ignored contacts */}
        {!!event?.ContactsAndAssetsCriteria?.ExcludeContacts?.length && (
          <div className="mb-4">
            <MyCollapse
              heading={
                <div className="fw-bold fs-4 flex-grow-1 d-flex align-items-center justify-content-between">
                  Ignored Contacts:
                  <span className="badge rounded-pill bg-secondary ms-2 fs-6">
                    {event?.ContactsAndAssetsCriteria?.ExcludeContacts?.length}
                  </span>
                </div>
              }
            >
              <div className="mt-2">
                <div className="d-flex justify-content-end">
                  <button
                    className="btn border-0 text-purple btn-small btn-outline-light border-0 p-0 px-3"
                    onClick={() =>
                      setEvent({
                        ...event,
                        ContactsAndAssetsCriteria: {
                          ...event.ContactsAndAssetsCriteria,
                          ExcludeContacts: [],
                        },
                      })
                    }
                    title="Remove all ignored contacts"
                  >
                    Clear all
                  </button>
                </div>
                <Contacts
                  filters={undefined}
                  fields={undefined}
                  useSearchOptions={true}
                  includeContacts={
                    event?.ContactsAndAssetsCriteria?.ExcludeContacts
                  }
                  ignoreContacts={undefined}
                  ignoreSets={undefined}
                  contactSet={undefined}
                  contactSets={[]}
                  strictCriteria={undefined}
                  doNotUseSets={undefined}
                  contactButton={(c: any) => (
                    <button
                      className="btn btn-small p-0 px-2 btn-outline-light border-0 text-purple"
                      onClick={() => {
                        setEvent({
                          ...event,
                          ContactsAndAssetsCriteria: {
                            ...event.ContactsAndAssetsCriteria,
                            ExcludeContacts:
                              event?.ContactsAndAssetsCriteria?.ExcludeContacts?.filter(
                                (uuid) => uuid !== c.uuid
                              ) || [],
                          },
                        });
                      }}
                    >
                      <FontAwesomeIcon icon={faMinus} />
                    </button>
                  )}
                  notDraggable={undefined}
                  onDrop={undefined}
                  allContactsButton={undefined}
                  isModal={undefined}
                  showContactFields={undefined}
                  setSelectedContacts={undefined}
                  fullView={false}
                />
              </div>
            </MyCollapse>
          </div>
        )}
      </Col>
    </Row>
  );
}
